// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"2987d7bc","316":"6237f34a","366":"65b143c1","436":"c2f2d981","453":"e31fbc67","550":"95391788","551":"050b6476","787":"1bde0fba","941":"c6b17577"}[chunkId] + ".chunk.js";
};